/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: number;
};

export function AdminAdvertisementMod(routeProps: RouteComponentProps) {
  const { match, location } = routeProps;
  const history = useHistory();
  const { id } = match.params as Params;

  const [savedFile, setSavedFile] = useState<File>();
  const [savedFileName, setSavedFileName] = useState<string>('');
  const [removingFile, setRemovingFile] = useState<any>();
  const [savingFile, setSavingFile] = useState<File>();
  const [sortNumber, setSortNumber] = useState<number>();
  const [siteUrlText, setSiteUrlText] = useState<string>('');
  const [collegeText, setCollegeText] = useState('');
  const [targetText, setTargetText] = useState('_blank');
  const [fileUrl, setFileUrl] = useState('');

  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (+id > 0) {
      server.getAdvertisement(Number(id)).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setSortNumber(payload.sort);
          setSiteUrlText(payload.siteUrl);
          setSavedFile(payload.image);
          setCollegeText(payload.college);
          setSavedFile(payload.imageUrl);
          setSavedFileName(payload.image);
        }
      });
    }
  }, []);

  const updateAdvertisement = async () => {
    if (window.confirm('수정 하시겠습니까?')) {
      const savedData = await server
        .updateAdvertisements(Number(id), {
          sort: Number(sortNumber),
          siteUrl: siteUrlText,
          college: collegeText,
          target: targetText,
        })
        .then((payload) => {
          history.push(`/admin/banner-logo/advertisement`);
          dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
          return payload;
        });

      if (savedData !== undefined) {
        if (savingFile !== undefined) {
          await server
            .AdvertisementsFileUpload(id, { image: savingFile })
            .then(() => {
              history.push(`/admin/banner-logo/advertisement`);
            })
            .catch((error) => {
              dispatch(toast.error({ message: '첨부파일 에러 ' }));
              return error;
            });
        }
      }
    }
  };

  return (
    <main className="images wrapper">
      <div className="title">
        <h1>광고 수정하기</h1>
        <div className="buttons">
          <button type="button" onClick={() => updateAdvertisement()}>
            수정
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li className="input">
            <span className="required">정렬 순서</span>
            <input
              type="number"
              defaultValue={sortNumber}
              onChange={(e) => {
                setSortNumber(Number(e.target.value));
              }}
            />
          </li>
          <li>
            <span className="required">현재 광고 이미지</span>
            <span>
              <img
                src={savedFile ? `${process.env.REACT_APP_API_URL}/public/${savedFile}` : ''}
                alt={savedFileName}
              />
            </span>
          </li>
          <li>
            <span className="required">등록할 광고 이미지</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file02"
                type="file"
                onChange={(e) => {
                  if (
                    e.target !== null &&
                    e.target.files !== null &&
                    e.target.files[0] !== undefined
                  ) {
                    // console.log(e.target.files[0]);
                    setSavingFile(e.target.files[0]);
                    const preview = e.target.files[0];
                    const imageUrl = URL.createObjectURL(preview);
                    setFileUrl(imageUrl);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file02" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <img
              src={fileUrl}
              alt={savingFile?.name}
              onLoad={() => {
                dispatch(toast.info({ message: '이미지 업로드 완료.' }));
                window.URL.revokeObjectURL(fileUrl);
              }}
            />
            <small>※ 사이즈: 1200x326 (픽셀)</small>
          </li>
          <li>
            <span>연결 URL</span>
            <input
              className="full"
              type="url"
              defaultValue={siteUrlText}
              onChange={(e) => {
                setSiteUrlText(e.target.value);
              }}
            />
            <small>※ 대학교재 배너일 경우에는 입력하지 않으셔도 됩니다.</small>
          </li>
          <li>
            <span>대학명</span>
            <input
              type="text"
              defaultValue={collegeText}
              onChange={(e) => {
                setCollegeText(e.target.value);
              }}
            />
            <small>※ 해당 대학교재 판매시</small>
          </li>
        </ul>
      </div>
    </main>
  );
}
